/**
 * Account maintenance (Bill 2026-10-17) — v3/maintenance/*. The server builds each request from Core and gates it
 * on the administrator's switches; everything after creation is the opening flow on the cart.
 */
import type {
  RequestOptions,
  MaintenanceActionsResponse,
  MaintenanceCreateInput,
  MaintenanceCreateResponse,
  MaintenanceDescription,
  MaintenancePendingApprovalsResponse,
} from '@retail-ops/shared-types';
import type { ApiHttpClient } from '../http.js';

export class MaintenanceApi {
  public constructor(private readonly http: ApiHttpClient) {}

  /** Which maintenance actions are switched on. */
  public actions(opts?: RequestOptions): Promise<MaintenanceActionsResponse> {
    return this.http.get<MaintenanceActionsResponse>('/v3/maintenance/actions', { ...opts });
  }

  /** Start a maintenance request; returns the new cart's id. */
  public create(input: MaintenanceCreateInput, opts?: RequestOptions): Promise<MaintenanceCreateResponse> {
    return this.http.post<MaintenanceCreateResponse>('/v3/maintenance/carts', { ...opts, body: input });
  }

  public get(cartId: string, opts?: RequestOptions): Promise<MaintenanceDescription> {
    return this.http.get<MaintenanceDescription>(`/v3/maintenance/carts/${encodeURIComponent(cartId)}`, { ...opts });
  }

  /** Record the approval the bank's rule requires (approver must hold the role and not be the requester). */
  public approve(cartId: string, opts?: RequestOptions): Promise<MaintenanceDescription> {
    return this.http.post<MaintenanceDescription>(`/v3/maintenance/carts/${encodeURIComponent(cartId)}/approve`, { ...opts, body: {} });
  }

  public pendingApprovals(opts?: RequestOptions): Promise<MaintenancePendingApprovalsResponse> {
    return this.http.get<MaintenancePendingApprovalsResponse>('/v3/maintenance/pending-approvals', { ...opts });
  }
}
